import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPpday65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_65: Record<
  Exclude<PageIdWoofzPpday65, PageIdWoofzPpday65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PPDAY_65_N]: {
    id: PageId.SUBSCRIPTIONS_PPDAY_65_N,
  },
  [PageId.CHAT_UPSELL_PPDAY_65]: {
    id: PageId.CHAT_UPSELL_PPDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PPDAY_65]: {
    id: PageId.UPSELL_PPDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_PPDAY_65]: {
    id: PageId.DOWNLOAD_PPDAY_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
